<button type="button" class="btn btn-primary btn-sm">Small button</button>
<button type="button" class="btn btn-primary btn-rg">Regular button</button>
<button type="button" class="btn btn-primary btn-md">Default button</button>
<button type="button" class="btn btn-primary btn-lg">Large button</button>
